export interface NavigationIntent {
    targetPath?: string;
    tabIndex?: number;
    params?: any;
    action?: string;
    companyId?: string;
    timestamp: number;
}

export const persistNavigationIntent = (targetPath: string, tabIndex = 0, params: any = {}) => {
    localStorage.setItem(
        'pending_nav_intent',
        JSON.stringify({
            targetPath,
            tabIndex,
            params,
            timestamp: Date.now(),
            ...params,
        }),
    );
};

export const consumeNavigationIntent = (): NavigationIntent | null => {
    const intentStr = localStorage.getItem('pending_nav_intent');
    if (!intentStr) return null;

    try {
        const intent = JSON.parse(intentStr) as NavigationIntent;
        if (Date.now() - intent.timestamp > 300000) {
            localStorage.removeItem('pending_nav_intent');
            return null;
        }
        localStorage.removeItem('pending_nav_intent');
        return intent;
    } catch (e) {
        localStorage.removeItem('pending_nav_intent');
        return null;
    }
};
